import type { MenuProps } from 'antd';
import { Menu } from 'antd';
import React, { useMemo } from 'react';
import { Link } from 'react-router';
import type { MenuDataProps } from '@/components/AntdForm/antd-components.def.ts';
import { useVisibleNavMenuData } from '@/components/layouts/nav-menu-visibility.ts';

type MenuItem = Required<MenuProps>['items'][number];

/** Builds antd items from an already-filtered tree (see `filterVisibleNavMenu`). */
const menuDataToItems = (data: MenuDataProps[], parentKey = ''): MenuItem[] =>
  data.map((x) => ({
    key: parentKey ? `${parentKey}.${x.key}` : x.key,
    label: x.url ? (
      <Link to={x.url} style={{ color: 'inherit' }} target={x.target}>
        {x.label}
      </Link>
    ) : (
      x.label
    ),
    icon: x.icon,
    children: x.children?.length ? menuDataToItems(x.children, x.key) : undefined,
  }));

export const NavMenu: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  const visibleMenuData = useVisibleNavMenuData();
  const navItems = useMemo(() => menuDataToItems(visibleMenuData), [visibleMenuData]);

  return (
    <Menu
      theme="dark"
      selectable={false}
      items={navItems}
      mode="inline"
      inlineCollapsed={collapsed}
      className="bg-inherit [--ant-menu-item-color:inherit]"
    />
  );
};
